export enum ProviderType {
  OpenFinance = 1,
  OFX = 2,
  Stone = 3,
  Pagarme = 4,
  Manual = 99,
}

export enum BankProvider {
  Ofx = 0,
  OpenFinance = 1,
  Asaas = 2,
  Stone = 3,
  Pagarme = 4,
  Sicoob = 5,
  Manual = 6,
}

export enum HealthStatus {
  Healthy = 1,
  Degraded = 2,
  Offline = 3,
}

export enum ConnectionStatus {
  Active = 1,
  ReAuthRequired = 2,
  Expired = 3,
  Disabled = 4,
}

export enum ReconciliationStatus {
  Pending = 1,
  Matched = 2,
  ManualMatch = 3,
  Exception = 4,
  Ignored = 5,
  NoMatchRequired = 6,
}

export enum SuggestionStatus {
  Pending = 1,
  Accepted = 2,
  Rejected = 3,
  Expired = 4,
}

export enum FlowDirection {
  In = 0,
  Out = 1,
}

export enum MatchMethod {
  AutoRuleBased = 1,
  AutoML = 2,
  Manual = 3,
  SuggestedConfirmed = 4,
  Ai = 5,
}

export enum ReconciliationAction {
  Matched = 1,
  Unmatched = 2,
  SuggestionCreated = 3,
  ManualMatch = 4,
  Exception = 5,
  Ignored = 6,
}
